var _circle, _g, _circle2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardIconBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 26,
    r: 20,
    fill: "#F5F7F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6695:46458)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.806 29.0439H17.0838C16.9733 29.0439 16.8673 29.0878 16.7891 29.166C16.711 29.2441 16.6671 29.3501 16.6671 29.4606V30.8495C16.6671 30.96 16.711 31.066 16.7891 31.1441C16.8673 31.2223 16.9733 31.2662 17.0838 31.2662H21.806C21.9165 31.2662 22.0225 31.2223 22.1006 31.1441C22.1788 31.066 22.2227 30.96 22.2227 30.8495V29.4606C22.2227 29.3501 22.1788 29.2441 22.1006 29.166C22.0225 29.0878 21.9165 29.0439 21.806 29.0439ZM15.1393 29.0439H12.6393C12.5288 29.0439 12.4228 29.0878 12.3447 29.166C12.2666 29.2441 12.2227 29.3501 12.2227 29.4606V30.8495C12.2227 30.96 12.2666 31.066 12.3447 31.1441C12.4228 31.2223 12.5288 31.2662 12.6393 31.2662H15.1393C15.2498 31.2662 15.3558 31.2223 15.434 31.1441C15.5121 31.066 15.556 30.96 15.556 30.8495V29.4606C15.556 29.3501 15.5121 29.2441 15.434 29.166C15.3558 29.0878 15.2498 29.0439 15.1393 29.0439Z",
    fill: "#668598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 17.9326H11.6667C11.2246 17.9326 10.8007 18.1082 10.4882 18.4208C10.1756 18.7333 10 19.1573 10 19.5993V31.8215C10 32.2635 10.1756 32.6875 10.4882 33C10.8007 33.3126 11.2246 33.4882 11.6667 33.4882H28.3333C28.7754 33.4882 29.1993 33.3126 29.5118 33C29.8244 32.6875 30 32.2635 30 31.8215V19.5993C30 19.1573 29.8244 18.7333 29.5118 18.4208C29.1993 18.1082 28.7754 17.9326 28.3333 17.9326ZM15.5556 30.8493C15.5556 30.9598 15.5117 31.0658 15.4335 31.1439C15.3554 31.222 15.2494 31.2659 15.1389 31.2659H12.6389C12.5284 31.2659 12.4224 31.222 12.3443 31.1439C12.2661 31.0658 12.2222 30.9598 12.2222 30.8493V29.4604C12.2222 29.3499 12.2661 29.2439 12.3443 29.1658C12.4224 29.0876 12.5284 29.0437 12.6389 29.0437H15.1389C15.2494 29.0437 15.3554 29.0876 15.4335 29.1658C15.5117 29.2439 15.5556 29.3499 15.5556 29.4604V30.8493ZM22.2222 30.8493C22.2222 30.9598 22.1783 31.0658 22.1002 31.1439C22.022 31.222 21.9161 31.2659 21.8056 31.2659H17.0833C16.9728 31.2659 16.8668 31.222 16.7887 31.1439C16.7106 31.0658 16.6667 30.9598 16.6667 30.8493V29.4604C16.6667 29.3499 16.7106 29.2439 16.7887 29.1658C16.8668 29.0876 16.9728 29.0437 17.0833 29.0437H21.8056C21.9161 29.0437 22.022 29.0876 22.1002 29.1658C22.1783 29.2439 22.2222 29.3499 22.2222 29.4604V30.8493Z",
    fill: "#668598"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 9,
    r: 8.25,
    fill: "#668598",
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.753 8.5H35.3775V7.375C35.3775 6.06562 34.3106 5 32.9995 5C31.6885 5 30.6215 6.06562 30.6215 7.375V8.5H30.2461C29.8315 8.5 29.4951 8.83594 29.4951 9.25V12.25C29.4951 12.6641 29.8315 13 30.2461 13H35.753C36.1676 13 36.504 12.6641 36.504 12.25V9.25C36.504 8.83594 36.1676 8.5 35.753 8.5ZM34.126 8.5H31.8731V7.375C31.8731 6.75469 32.3784 6.25 32.9995 6.25C33.6206 6.25 34.126 6.75469 34.126 7.375V8.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6695:46458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconBuilder);
export default __webpack_public_path__ + "static/media/CardIconBuilder.f3137de7.svg";
export { ForwardRef as ReactComponent };